import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.string.link.js";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Text from 'components/Text';
import useCallbackRef from 'hooks/useCallbackRef';
import ButtonPanel from './ButtonPanel';
import { useAutoCompletion } from '../AutoCompleteWrapper';
var linkDescriptionId = 'open-external-link-description';
var ExternalLinkPanel = function ExternalLinkPanel(_ref) {
  var asset = _ref.asset,
    link = _ref.link,
    autoCompleteEnabled = _ref.autoCompleteEnabled,
    onLoad = _ref.onLoad,
    onComplete = _ref.onComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onLoadRef = useCallbackRef(onLoad);

  // as links don't actually get "loaded" per se, we just call `onLoad` right away
  useEffect(function () {
    if (asset) {
      onLoadRef.current();
    }
  }, [asset, onLoadRef]);
  var _useAutoCompletion = useAutoCompletion({
      autoCompleteEnabled: autoCompleteEnabled,
      userContentStatus: asset.userContentStatus,
      onComplete: onComplete
    }),
    markAsCompleted = _useAutoCompletion.markAsCompleted;

  // FYI window.open is needed for microsite popup window
  // as popup would try to send notification to the hub using:
  // window.opener.postMessage(...);
  // when used as a link, window.opener is null
  var buttonProps = {
    onClick: function onClick() {
      window.open(link, '_blank');
      markAsCompleted();
    }
  };
  return /*#__PURE__*/React.createElement(ButtonPanel, {
    asset: asset,
    imageButtonProps: buttonProps
  }, /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    variant: "primary",
    icon: "external",
    "aria-describedby": linkDescriptionId
  }), t('actions_open_link')), /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    as: "p",
    size: "s",
    mt: "xs",
    id: linkDescriptionId
  }, t('external_link_opens_in_new_tab')));
};
export default ExternalLinkPanel;